import cacetto from '../images/png/prodotti/cacetti.png';
import ragusano from '../images/png/prodotti/ragusano.png';
import semistagionato from '../images/png/prodotti/semistagionato.png';
import ricotta from '../images/png/prodotti/ricotta1.png';
import provola from '../images/png/prodotti/provola.png';

import { Component } from 'react';
import Card from '../components/card';


class Negozio extends Component {

    state = {
        cards: [
            { id:0, nome: "Cacetto", prezzo: 0.00, immagine: cacetto },
            { id:1, nome: "Ragusano", prezzo: 0.00, immagine: ragusano },
            { id:2, nome: "Semistagionato", prezzo: 0.00, immagine: semistagionato },
            { id:3, nome: "Ricotta", prezzo: 0.00, immagine: ricotta },
            { id:4, nome: "Provola", prezzo: 0.00, immagine: provola }
        ]
    }

    render() {

        return (

            <div class="container" id="negozio">
                <h2> Alcuni dei nostri prodotti </h2>
                
                <div className='row'>
                    {this.state.cards.map(card => (
                        <Card 
                            key={card.id} 
                            card={card} /> 
                    ))

                    }
                </div>
                    
    
            </div>
    
        )

    }

}


export default Negozio;